<template>
  <div>
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
      <el-form-item label="套餐系列：">
        <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" clearable></el-input>
      </el-form-item>
      <el-form-item label="套餐类型：">
        <el-select v-model="searchForm.isVoice" clearable>
          <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
            :label="item.description"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跨月类型：">
        <el-select v-model="searchForm.isNextMonth" clearable>
          <el-option label="跨月" value="1"></el-option>
          <el-option label="自然月" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="余额限制：">
        <el-select v-model="searchForm.type" clearable>
          <el-option label="不限制" value="0"></el-option>
          <el-option label="限制余额" value="1"></el-option>
          <el-option label="限制余额并且开户预存" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" plain icon="el-icon-search" @click="getPkgGroupListPageHandle">搜索</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="showAddPkgGroup">新建系列</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
      :header-cell-style="{ background: '#f5f5f5' }">
      <el-table-column prop="name" label="系列名称" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="typeName" label="余额限制" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isNextMonthName" label="跨月类型" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="limitName" label="限速设置" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="xuliangName" label="虚量设置" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="stateName" label="状态" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="subId" label="商户号" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isDownNAme" label="自动续费" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isAuthName" label="实名限制" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isMiaoName" label="秒反类型" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="290">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup(scope.row)">购卡配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup11(scope.row)">推送配置</el-button>
          <el-button type="text" size="small" @click="updateAutoState(scope.row)">余额续费</el-button>
          <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">
            <span style="color: red;">
              {{ showbtnText(scope.row.state) }}
            </span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
      layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel"
      :close-on-click-modal="false">
      <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
        <el-form-item label="套餐组名称：" prop="name">
          <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="余额限制：" prop="type">
          <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
            <el-option v-for="item in isPriceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额购买参数：" prop="priceData">
          <el-input v-model.trim="addOrEditGroupForm.priceData" placeholder="严谨按照参数规范填写 参数示列请点击下方按钮" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否跨月：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
            <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="套餐类型：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isVoice" placeholder="请选择">
            <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="秒反设置：" prop="isMiao">
          <el-select v-model="addOrEditGroupForm.isMiao" placeholder="请选择">
            <el-option v-for="item in isMiaoList" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="addOrEditGroupForm.isMiao > 0" label="秒反金额/元：" prop="miaoPrice">
          <el-input v-model.trim="addOrEditGroupForm.miaoPrice" placeholder="后续降低秒反金额，需要重新给代理商！" clearable></el-input>
        </el-form-item>

        <el-form-item label="实名跳转：" prop="poolName">
          <el-input v-model.trim="addOrEditGroupForm.poolName" placeholder="控制实名跳转，电信卡请填 电信 ，联通卡 填联通。特殊实名链接 请直接填链接"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="微信弹窗内容：" prop="remark">
          <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="将会在微信套餐页面进行弹窗提示" clearable></el-input>
        </el-form-item>
        <el-form-item label="自动续费：" prop="">
          <el-radio-group v-model="addOrEditGroupForm.isDown">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="实名限制：" prop="isAuth">
          <el-radio-group v-model="addOrEditGroupForm.isAuth">
            <el-radio :label="1">无限制</el-radio>
            <el-radio :label="0">先套餐后实名</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="限速规则：">
          <el-select v-model="addOrEditGroupForm.limitId" clearable filterable>
            <el-option v-for="item in branchSupplierOption" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="阶梯虚量：">
          <el-select v-model="addOrEditGroupForm.xuliangId" clearable filterable>
            <el-option v-for="item in branchSupplierOptions" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提前停机：" prop="stopData">
          <el-input v-model.trim="addOrEditGroupForm.stopData" placeholder="当套餐剩余流量小于设置数时（单位/M），进行停机"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="商户号：" prop="subId">
          <el-input v-model.trim="addOrEditGroupForm.subId" placeholder="微信商户号" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户密钥：" prop="subKey">
          <el-input v-model.trim="addOrEditGroupForm.subKey" placeholder="微信商户密钥" clearable></el-input>
        </el-form-item>


        <el-form-item label="日限额：" prop="dayLimitData">
          <el-input v-model.trim="addOrEditGroupForm.dayLimitData" placeholder="当日真实使用多少GB时，进行停机。次日恢复"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="月限额：" prop="monthLimitData">
          <el-input v-model.trim="addOrEditGroupForm.monthLimitData" placeholder="当月真实使用多少GB时，进行停机。次月恢复(不支持跨月)"
            clearable></el-input>
        </el-form-item>


        <el-form-item label="购买限制：" prop="isFirstPkg">
          <el-radio-group v-model="addOrEditGroupForm.isFirstPkg">
            <el-radio :label="1">限制购买首套餐</el-radio>
            <el-radio :label="0">不限制</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="代理修改售价：" prop="isUpdate">
          <el-radio-group v-model="addOrEditGroupForm.isUpdate">
            <el-radio :label="1">不允许修改</el-radio>
            <el-radio :label="0">允许需改</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="无次月停机：" prop="stopDay">
          <el-input v-model.trim="addOrEditGroupForm.stopDay" placeholder="当套餐的最大有效期小于多少天时，开始停机。 时间大于0"
            clearable></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="showYue">查询余额参数示列</el-button>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1"
      :close-on-click-modal="false">
      <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：最多只支持6个参数，amount代表充值金额/元
        giftBalance表示赠送金额/元。请修改后完整输入此参数</div>
      <div style="text-align: center; width:100%;">
        <p alt="" style="margin: 0 auto;">{{ urls }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商品展示图(建议像素512*512)：">
          <input type="file" ref="file1" placeholder="必选" />
          <img :src="getImgUrl() + shareForm.shareImg" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="商品标题:" prop="shareName">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareName" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类:" prop="shareType">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareType" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商品价格/元:" prop="sharePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.sharePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="分代理商佣金/元:" prop="shareYongjing">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareYongjing" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="上下架状态：" prop="isShare">
          <el-radio-group v-model="shareForm.isShare">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类排序:" prop="shareTypeOrderBy">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareTypeOrderBy" placeholder="选填（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品排序:" prop="shareShopOrderBY">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareShopOrderBY" placeholder="选填（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="autoFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="updateAuto" :model="updateAuto" label-width="120px">

        <el-form-item label="续费类型：" prop="xuType">
          <el-radio-group v-model="updateAuto.xuType">
            <el-radio :label="1">套餐续费次月</el-radio>
            <el-radio :label="0">流量用完续费</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="续费状态：" prop="xuState" v-if="updateAuto.xuType == 1">
          <el-radio-group v-model="updateAuto.xuState">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">自动订购上次套餐</el-radio>
            <el-radio :label="2">自定义套餐编码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="续费套餐编码:" prop="xuPkg" v-if="updateAuto.xuType == 1 && updateAuto.xuState == 2">
          <el-col :span="22">
            <el-input v-model.trim="updateAuto.xuPkg" placeholder="套餐编码在套餐详情中查询" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="提前续费天数:" prop="xuDay" v-if="updateAuto.xuType == 1">
          <el-col :span="22">
            <el-input v-model.trim="updateAuto.xuDay" placeholder="套餐前几天进行续费" clearable></el-input>
          </el-col>
        </el-form-item>


        <el-form-item label="续费套餐编码:" prop="autoState" v-if="updateAuto.xuType == 0">
          <el-col :span="22">
            <el-input v-model.trim="updateAuto.autoPkgId" placeholder="流量超套后 将会自动用余额续费此套餐" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="续费状态：" prop="autoState" v-if="updateAuto.xuType == 0">
          <el-radio-group v-model="updateAuto.autoState">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="updateAutoSure()">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" title="推送配置" :visible.sync="pushFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="pushData" :model="pushData" label-width="120px">
        <el-form-item label="套餐预警推送：" prop="wxMsgState">
          <el-radio-group v-model="pushData.wxMsgState">
            <el-radio :label="0">开启</el-radio>
            <el-radio :label="1">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="套餐购买推送：" prop="wxPkgMsgState">
          <el-radio-group v-model="pushData.wxPkgMsgState">
            <el-radio :label="0">关闭推送</el-radio>
            <el-radio :label="2">购套餐推送</el-radio>
            <el-radio :label="1">仅首充推送</el-radio>
          </el-radio-group>
        </el-form-item>
        <p style="color:red">上面是微信推送配置，下面是短信配置推送。 互不关联</p>
        <el-form-item label="短信推送模板ID:" prop="smsMsgId">
          <el-col :span="22">
            <el-input v-model.trim="pushData.smsMsgId" placeholder="不填，则不进行短信推送" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="短信到期日期:" prop="smsMsgDay">
          <el-col :span="22">
            <el-input v-model.trim="pushData.smsMsgDay" placeholder="填5则到期第五天发送短信通知。多个日期，逗号隔开" clearable></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle11">确 定</el-button>
      </div>
    </el-dialog>



  </div>
</template>
<script>
import { getPkgGroupListPage, addPkgGroup, updatePkgGroup, changePkgGroupState, getPkgIsMonthOption } from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
  data() {
    return {
      pushData: {
        id: '',
        smsMsgId: '',
        smsMsgDay: '',
        wxMsgState: '',
        wxPkgMsgState: ''
      },
      pushFlg: false,
      autoFlg: false,
      updateAuto: {
        xuType: 1,
        id: '',
        autoState: '',
        autoPkgId: '',
        xuDay: '',
        xuPkg: '',
        xuState: ''
      },
      existBackImg: false,
      shareGroup: false,
      existBackImg1: false,
      shareGroup1: false,
      shareGroup11: false,
      shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",
        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",

        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

      },
      isMiaoList: [

        {
          code: 0,
          description: '不秒反'
        },
        {
          code: 1,
          description: '一次性秒反'
        },
        {
          code: 2,
          description: '一次性秒反+套餐秒反'
        }
      ],
      urls: '',
      shareImgs: false,
      searchForm: {
        name: '',
        isVoice: '',



        isNextMonth: ''
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      addOrEditGroupForm: {
        stopDay: '',
        isUpdate: '',
        isFirstPkg: '',
        name: '',
        type: '',
        isAuth: '',
        subId: '',
        subKey: '',
        isNextMonth: '',
        supplierType: '1',
        remark: '',
        isDown: '',
        limitId: '',
        xuliangId: '',
        priceData: '',
        stopData: '',
        shareType: '',
        shareYongjing: '',
        miaoPrice: '',
        isMiao: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

        poolName: '',
        isVoice: '',

        dayLimitData: '',
        monthLimitData: '',
      },
      branchSupplierOption: [],
      branchSupplierOptions: [],
      isPriceOption: [
        {
          code: 0,
          description: '不限制'
        },
        {
          code: 1,
          description: '限制余额'
        },
        {
          code: 2,
          description: '限制余额并且开户预存'
        }
      ],
      isVoiceOption: [
        {
          code: 0,
          description: '流量'
        },
        {
          code: 1,
          description: '流量+语音'
        }
      ],
      currentId: '',
      addFlag: null,
      addGroupVisibale: false,
      title: '',
      pkgTypeOption: [],
      supplierOption: [],
      isMonthOption: [],
      addOrEditGroupRules: {
        name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        isNextMonth: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        supplierType: [{ required: true, message: '请选择套餐名称', trigger: 'change' }]
      }
    }
  },
  methods: {

    sharePkgGroup11(row) {
      this.pushData.id = row.id;
      this.pushData.wxMsgState = row.wxMsgState;
      this.pushData.smsMsgDay = row.smsMsgDay;
      this.pushData.smsMsgId = row.smsMsgId;
      this.pushData.wxPkgMsgState = row.wxPkgMsgState;
      this.pushFlg = true;
    },
    addOrEidtPkgHandle11() {
      common.sysRequest("pkg/group/update/push/info", this.pushData, "post").then((res) => {
        if (res.data.code == 200) {
          this.getPkgGroupListPageHandle();
          this.pushFlg = false;
          this.$message.success(res.data.message);

        } else {
          this.$message.error(res.data.message);
        }
      })
        .catch((err) => console.error(err));
    },



    updateAutoSure() {
      common.sysRequest("pkg/group/update/auto/pkg", this.updateAuto, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.autoFlg = false;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    updateAutoState(row) {
      this.updateAuto.id = row.id;
      this.updateAuto.autoPkgId = row.autoPkgId;
      this.updateAuto.autoState = row.autoState;

      this.updateAuto.xuDay = row.xuDay;
      this.updateAuto.xuState = row.xuState;
      this.updateAuto.xuPkg = row.xuPkg;
      this.autoFlg = true;
    },
    addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file1.value = "";
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    cancel12() {
      this.pushFlg = false;
      this.autoFlg = false;
      this.shareGroup = false;
      this.existBackImg1 = false;
      this.shareGroup1 = false;
      this.shareGroup11 = false;
      this.$refs.shareForm.resetFields();
    },
    sharePkgGroup(row) {

      this.shareForm.shareType = row.shareType;
      this.shareForm.sharePrice = row.sharePrice;
      this.shareForm.shareYongjing = row.shareYongjing;
      this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.shareForm.shareShopOrderBY = row.shareShopOrderBY;

      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.existBackImg = true;
      this.shareGroup = true;
    },
    //复制功能
    copy() {
      var clipboard = new Clipboard('.copy_url')
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        this.shareImgs = false;
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.success('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    showYue() {
      this.urls = '[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]'
      this.shareImgs = true;
    },
    cancel() {
      this.shareImgs = false;
      this.addGroupVisibale = false;
      this.$refs.addOrEditGroupForm.resetFields();
    },
    cancel1() {
      this.shareImgs = false;
    },
    showbtnText(state) {
      return common.showTxtByState(state, { 0: '启用', 1: '禁用' })
    },
    getPkgGroupListPageHandle($event) {
      common.resetCurrentPage(this, $event, 'tbpg');
      var data = common.getRequestParams(this, 'tbpg', this.searchForm);
      getPkgGroupListPage(data).then(res => {
        common.listCallback(this, res, 'tbpg');
      })
    },
    showAddPkgGroup() {
      this.addGroupVisibale = true;
      this.addFlag = true;
      this.title = "新增套餐组";
      this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
    },
    showEditPkgGroup(row) {
      this.addGroupVisibale = true;
      this.addFlag = false;
      this.title = "修改套餐组";
      this.addOrEditGroupForm.stopDay = row.stopDay;
      this.addOrEditGroupForm.isUpdate = row.isUpdate;

      this.addOrEditGroupForm.isFirstPkg = row.isFirstPkg;

      this.addOrEditGroupForm.dayLimitData = row.dayLimitData;
      this.addOrEditGroupForm.monthLimitData = row.monthLimitData;


      this.addOrEditGroupForm.shareType = row.shareType;
      this.addOrEditGroupForm.isMiao = row.isMiao;
      this.addOrEditGroupForm.miaoPrice = row.miaoPrice;
      this.addOrEditGroupForm.shareYongjing = row.shareYongjing;
      this.addOrEditGroupForm.subId = row.subId;
      this.addOrEditGroupForm.subKey = row.subKey;
      this.addOrEditGroupForm.sharePrice = row.sharePrice;
      this.addOrEditGroupForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.addOrEditGroupForm.shareShopOrderBY = row.shareShopOrderBY;
      this.addOrEditGroupForm.stopData = row.stopData;
      this.addOrEditGroupForm.isAuth = row.isAuth;
      this.addOrEditGroupForm.limitId = row.limitId;
      this.addOrEditGroupForm.xuliangId = row.xuliangId;
      this.addOrEditGroupForm.name = row.name;
      this.addOrEditGroupForm.type = row.type;
      this.addOrEditGroupForm.isVoice = row.isVoice;
      this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
      this.addOrEditGroupForm.supplierType = row.supplierType;
      this.addOrEditGroupForm.remark = row.remark;
      this.addOrEditGroupForm.poolName = row.poolName;
      this.addOrEditGroupForm.priceData = row.priceData;
      this.currentId = row.id;
      this.addOrEditGroupForm.isDown = row.isDown;
    },
    addOrEidtGroupHandle() {
      this.$refs.addOrEditGroupForm.validate(valid => {
        if (valid) {
          var data = this.addOrEditGroupForm;
          if (this.addFlag == true) {
            addPkgGroup(data).then(res => callback(res))
          } else {
            data.id = this.currentId
            updatePkgGroup(data).then(res => callback(res))
          }
        }
        var _this = this;
        function callback(res) {
          if (res.data.code == 200) {
            _this.getPkgGroupListPageHandle();
            _this.addGroupVisibale = false;

          } else {
            _this.$message.error(res.data.message)
          }
        }
      })
    },
    changeStateHandle(id) {
      var data = {
        id
      }
      changePkgGroupState(data).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message)
          this.getPkgGroupListPageHandle();
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getPkgGroupListPageHandle();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val
      this.getPkgGroupListPageHandle();
    }
  },
  created() {
    this.getPkgGroupListPageHandle();
    common.getPkgTypeOptionCom(this, 'pkgTypeOption');
    common.getSupplierOptionCom(this, 'supplierOption');
    common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
    common.getSupplierLimitOptionComs(this, 'branchSupplierOptions')
    getPkgIsMonthOption().then(res => {
      if (res.data.code == 200) {
        this.isMonthOption = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    })
  }
}
</script>
<style></style>
